<div class="content">
  <ppl-icon *ngIf="icon || iconName"
            [svgIcon]="icon || iconName"
            width="18px"
            height="18px"
            [fill]="iconFill"
            class="type-icon"></ppl-icon>

  <div class="box_text">
    <ng-template *ngIf="textTemplate"
                 [ngTemplateOutlet]="textTemplate"></ng-template>

    <ng-container *ngIf="!textTemplate && text">{{ text }}</ng-container>
  </div>

  <div class="actions">
    <ng-template *ngIf="enableActions && actionsTemplate"
                 [ngTemplateOutlet]="actionsTemplate"></ng-template>

    <ppl-button *ngIf="enableActions && !actionsTemplate && buttonText"
                pplButton
                pplButtonSmall="xs"
                [pplButton7]="type"
                [disabled]="buttonDisabled"
                (click)="buttonClick.emit()">{{ buttonText }}</ppl-button>
    <ppl-icon *ngIf="enableClose"
              svgIcon="closering-red2"
              class="box_close"
              width="18px"
              height="18px"
              (click)="close.emit()"></ppl-icon>
  </div>
</div>
<div *ngIf="drawerOpen"
     class="drawer">
  <ng-template *ngIf="drawerTemplate"
               [ngTemplateOutlet]="drawerTemplate"></ng-template>
</div>
